const doc = [({"da":({"js":({"steps":({"timer":"Timeren"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;